import {Injectable} from '@angular/core';
import {cloneDeep, sortBy} from 'lodash';
import {COUNTRIES_LIST} from '../constants/countriesList';

export interface ILanguage {
  name: string;
  code: string;
}

export const LANGUAGES: ILanguage[] = [
  {'name': 'English', 'code': 'en'},
  {'name': 'Afrikaans', 'code': 'af'},
  {'name': 'Albanian', 'code': 'sq'},
  {'name': 'Amharic', 'code': 'am'},
  {'name': 'Armenian', 'code': 'hy'},
  {'name': 'Azerbaijani', 'code': 'az'},
  {'name': 'Arabic', 'code': 'ar'},
  {'name': 'Bengali', 'code': 'bn'},
  {'name': 'Bosnian', 'code': 'bs'},
  {'name': 'Bulgarian', 'code': 'bg'},
  {'name': 'Chinese Simplified', 'code': 'zh'},
  {'name': 'Chinese Traditional', 'code': 'zh-TW'},
  {'name': 'Croatian', 'code': 'hr'},
  {'name': 'Czech', 'code': 'cs'},
  {'name': 'Danish', 'code': 'da'},
  {'name': 'Dari', 'code': 'fa-AF'},
  {'name': 'Dutch', 'code': 'nl'},
  {'name': 'Estonian', 'code': 'et'},
  {'name': 'Finnish', 'code': 'fi'},
  {'name': 'French', 'code': 'fr'},
  {'name': 'French Canadian', 'code': 'fr-CA'},
  {'name': 'Georgian', 'code': 'ka'},
  {'name': 'German', 'code': 'de'},
  {'name': 'Greek', 'code': 'el'},
  {'name': 'Hausa', 'code': 'ha'},
  {'name': 'Hebrew', 'code': 'he'},
  {'name': 'Hindi', 'code': 'hi'},
  {'name': 'Hungarian', 'code': 'hu'},
  {'name': 'Indonesian', 'code': 'code'},
  {'name': 'Italian', 'code': 'it'},
  {'name': 'Japanese', 'code': 'ja'},
  {'name': 'Korean', 'code': 'ko'},
  {'name': 'Latvian', 'code': 'lv'},
  {'name': 'Lithuanian', 'code': 'lt'},
  {'name': 'Malay', 'code': 'ms'},
  {'name': 'Maltese', 'code': 'mt'},
  {'name': 'Norwegian', 'code': 'no'},
  {'name': 'Persian', 'code': 'fa'},
  {'name': 'Pashto', 'code': 'ps'},
  {'name': 'Polish', 'code': 'pl'},
  {'name': 'Portuguese', 'code': 'pt'},
  {'name': 'Romanian', 'code': 'ro'},
  {'name': 'Russian', 'code': 'ru'},
  {'name': 'Serbian', 'code': 'sr'},
  {'name': 'Slovak', 'code': 'sk'},
  {'name': 'Slovenian', 'code': 'sl'},
  {'name': 'Somali', 'code': 'so'},
  {'name': 'Spanish', 'code': 'es'},
  {'name': 'Swahili', 'code': 'sw'},
  {'name': 'Swedish', 'code': 'sv'},
  {'name': 'Tagalog', 'code': 'tl'},
  {'name': 'Tamil', 'code': 'ta'},
  {'name': 'Thai', 'code': 'th'},
  {'name': 'Turkish', 'code': 'tr'},
  {'name': 'Ukrainian', 'code': 'uk'},
  {'name': 'Urdu', 'code': 'ur'},
  {'name': 'Vietnamese', 'code': 'vi'}
];

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  public static getLanguages(): ILanguage[] {
    const sortingList = sortBy(COUNTRIES_LIST, 'name');

    return cloneDeep(sortingList);
  }
}
